import axios from "axios";
import * as urls from "../../components/maps/urls";

export async function getCovidTiers(prop_id, secret) {
  let payload = null;
  let params = { propid: prop_id };

  await axios({
    method: "get",
    url: urls.API_GATEWAY + "/covid/covid-tiers-property",
    params: params,
  })
    .then((res) => {
      console.log(res.data);
      payload = res.data;

      if (
        payload === "null" ||
        payload === null ||
        payload === "Failure" ||
        typeof payload === "undefined"
      ) {
        payload = null;
        console.log("Property Details getting ERROR");
      } else if (payload === "Invalid Details") {
        console.log("Credentials for getting Covid Tiers are INVALID");
        payload = null;
      } else if (payload === "No details found") {
        console.log("No Covid Tiers Data was found!");
        payload = null;
      } else {
        console.log("SUCCESS!!");
        console.log("Covid Tiers Data retrieved from the database.");
      }
    })
    .catch((err) => {
      payload = null;
      console.log("FAILURE!!");
      console.log("Covid Tiers getting ERROR");
      console.log(err);
    });
  return payload;
}
